import styled from 'styled-components';

export const DontHaveAutoScriptInstalled = styled.div`
  padding: 0 40px 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
`;
